import {
  KIT_ID_STEP_KEY,
  POST_REGISTRATION_INSTRUCTION_STEP_KEYS,
} from '@/flows/config/kitRegistrationStepKeys'
import { normalizePathname, PATIENT_PATHS } from '@/utilities/paths'

const REDIRECTS_TO_HOME = new Set([
  PATIENT_PATHS.flows.step(PATIENT_PATHS.flows.kitRegistration, KIT_ID_STEP_KEY),
  ...POST_REGISTRATION_INSTRUCTION_STEP_KEYS.flatMap((step) => [
    PATIENT_PATHS.flows.step(PATIENT_PATHS.flows.kitRegistration, step),
    PATIENT_PATHS.flows.step(PATIENT_PATHS.flows.sampleCollection, step),
  ]),
])

export function resolvePatientPostLoginDestination(
  isFirstTimeUser: boolean | null,
  redirectIntent: string | null,
  redirectUrl: string,
): string {
  if (isFirstTimeUser !== false) return redirectUrl
  if (!redirectIntent) return redirectUrl
  if (REDIRECTS_TO_HOME.has(normalizePathname(redirectIntent))) return redirectUrl
  return redirectIntent
}
